import { render, staticRenderFns } from "./HomeFourth.vue?vue&type=template&id=56ae5901&scoped=true"
import script from "./HomeFourth.vue?vue&type=script&lang=js"
export * from "./HomeFourth.vue?vue&type=script&lang=js"
import style0 from "./HomeFourth.vue?vue&type=style&index=0&id=56ae5901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae5901",
  null
  
)

export default component.exports